import client from "../../lib/api/client";

export const writeProject = ({ title, body, tags }) => {
    return client.post('/api/projects', {
        title,
        body,
        tags,
    });
};

export const readProject = (id) => {
    return client.get(`/api/projects/${id}`);
};

export const listProject = ({ page, username, tag }) => {
    return client.get('/api/projects', {
        params: { page, username, tag },
    });
    // GET /api/projects?username=tester&page=2&tag=..와 같이 주소를 만들어 호출한다.
};

export const updateProject = ({ id, title, body, tags }) => {
    return client.patch(`/api/projects/${id}`, {
        title,
        body,
        tags,
    });
};

export const removeProject = (id) => {
    return client.delete(`/api/projects/${id}`);
};